import React from "react";
import { Tag } from "antd";

const OttoAiCallTopics = ({ topics = [] }) => {
  return (
    <div>
      <div className="text-black/[0.65] text-sm font-semibold mb-2">Topics:</div>
      {topics && topics.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {topics.map((topic, index) => (
            <Tag key={index}>{topic}</Tag>
          ))}
        </div>
      ) : (
        <div className="text-sm text-gray-700">No topics identified for this call</div>
      )}
    </div>
  );
};

export default OttoAiCallTopics;
